import React, { useEffect, useRef, useState } from "react";
import { Card, CardBody, Col, Row, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import isEqual from 'lodash/isEqual';
import am4lang_es_ES from "@amcharts/amcharts4/lang/es_ES"
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);
am4core.options.minPolylineStep = 0.5;

const BarChart = ({ title, data, refValue, id, popoverTitle, popoverBody }) => {
  const chartRef = useRef();
  const [showPopover, setShowPopover] = useState(false);

  const handleShowPopover = () => {
    setShowPopover(true)
  }

  const handleHidePopover = () => {
    setShowPopover(false)
  }

  useEffect(() => {
    let chart = am4core.create(chartRef.current, am4charts.XYChart);
    chart.language.locale = am4lang_es_ES;
    chart.data = data;
    chart.numberFormatter.numberFormat = '#.##';
    chart.responsive.enabled = true;

    let xAxis = chart.xAxes.push(new am4charts.DateAxis());
    xAxis.dataFields.category = 'date';
    xAxis.groupData = true;
    xAxis.groupCount = 100;
    xAxis.renderer.grid.template.location = 0;

    let yAxis = chart.yAxes.push(new am4charts.ValueAxis());
    yAxis.renderer.minWidth = 35;
    yAxis.min = 0;
    yAxis.extraMax = 0.1;

    let refLine = yAxis.axisRanges.create();
    if(refValue && refValue > 0) {
      refLine.value = refValue;
      refLine.grid.stroke = am4core.color('#ff3e38');
      refLine.grid.strokeDasharray = "5";
      refLine.grid.strokeWidth = 2;
      refLine.grid.strokeOpacity = 1;
      refLine.grid.above = true;
    }

    let series = chart.series.push(new am4charts.LineSeries());
    series.name = "Series";
    series.dataFields.dateX = "date";
    series.dataFields.valueY = "value";
    series.tooltip.getFillFromObject = false;
    series.tooltip.background.fill = am4core.color("#fff");
    series.tooltip.label.fill = am4core.color("#00");
    series.strokeWidth = 2;

    let bullet = series.bullets.push(new am4charts.CircleBullet());
    bullet.circle.strokeWidth = 2;
    bullet.circle.radius = 4;
    bullet.tooltipText = "Valor: {value}";

    const cursor = new am4charts.XYCursor();
    chart.cursor = cursor;
    cursor.lineY.disabled = true;
    cursor.xAxis = xAxis;
    cursor.fullWidthLineX = true;
    cursor.lineX.strokeWidth = 0;
    cursor.lineX.fill = am4core.color("#888");
    cursor.lineX.fillOpacity = 0.1;

    chart.scrollbarX = new am4core.Scrollbar();

    return () => { chart.dispose() };
  }, [data]);

  return (
    <Card className="chart-card">
      <CardBody>
        <Row>
          <Col lg={8} md={8}>
            <h5>{title}</h5>
            </Col>
          <Col lg={4} md={4}>
            <i className="fas fa-question-circle float-right pointer" id={id} onClick={handleShowPopover}></i>
            <Popover placement="bottom" isOpen={showPopover} target={id} toggle={handleHidePopover}>
              <PopoverHeader>{popoverTitle}</PopoverHeader>
              <PopoverBody>{popoverBody}</PopoverBody>
            </Popover>
          </Col>
        </Row>
        <div
          ref={chartRef}
          style={{ height: '380px', width: '100%' }}
        />
      </CardBody>
    </Card>
  )
}

export default React.memo(BarChart, (prevProps, nextProps) => isEqual(prevProps, nextProps));
